var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.07 23.859l9.051-9.051c.39-.39.39-1.024 0-1.415l-1.414-1.414a1 1 0 00-1.414 0L7.979 23.293a1 1 0 000 1.414l11.314 11.314a1 1 0 001.414 0l1.414-1.414c.39-.39.39-1.024 0-1.415l-9.05-9.05a.199.199 0 010-.283z"
  })));
}
export default SvgArrowLeftWhite;